import React from 'react';
import { useState } from 'react';
import './../../Styles/Header/ModalMenu.scss';


function ModalMenu(props) {

   const [windowHeight, setWindowHeight] = useState(window.innerHeight - props.heightHeader);

   window.addEventListener('resize', () => {
      let height = document.querySelector('.wrapper-app').clientHeight;   
      setWindowHeight(height);
   })

   return (
      <div
         className='modal'
         style={{ height: windowHeight }}
      >
         <div className="modal__menu">
            {props.children}
         </div>
      </div>
   );
}
export default ModalMenu;